import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-toastify';
import ModalFilterOvertime from '../../components/Overtimes/modalFilterOvertime';
import { dateIndo, getStatusRewards, timeIndo } from '../../utilities/helper';
import ModalOvertimeDetail from '../../components/Overtimes/modalDetailOvertime';
import ModalOvertimeCreate from '../../components/Overtimes/modalCreateOvertime';
import ExportToExcel from '../../components/Exports/ExportToExcel';
import { getPendingOvertimes } from '../../utilities/sendRequest';

const Overtimes = () => {
    const [datas, setDatas] = useState([])
    const [data, setData] = useState([])
    const [showModalDetail, setShowModalDetail] = useState(false)
    const [showModalCreate, setShowModalCreate] = useState(false)
    const [showModalFilter, setShowModalFilter] = useState(false)
    const [fetchMore, setFetchMore] = useState(true)
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [division, setDivision] = useState("")
    const [divisionSlug, setDivisionSlug] = useState("")
	const fileName = "Report_Overtimes_" + format(new Date(), "yyyy-MM-dd_HH:mm:ss");

    useEffect(() => {
        setFetchMore(false)
        
        // eslint-disable-next-line
    }, [fetchMore])

    useEffect(() => {
        fetchPendingOvertimes();
    
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchPendingOvertimes = async () => {
        setStartTime("")
        setEndTime("")
        setDivision("")
        setDivisionSlug("")

        getPendingOvertimes().then((res) => {
            setDatas(
                res.payload.sort((p1, p2) => {
                    return new Date(p2.createdAt) - new Date(p1.createdAt)
                })
            )
        }).catch((err) => {
            toast.error(err.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        })  
    }

    const columns = [
        { 
            field: 'start_time', 
            headerName: 'Mulai',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {dateIndo(params.row.start_time)} {timeIndo(params.row.start_time)}
                    </div>
                )
            } 
        },
        { 
            field: 'end_time', 
            headerName: 'Sampai',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {dateIndo(params.row.end_time)} {timeIndo(params.row.end_time)}
                    </div>
                )
            } 
        },
        { 
            field: 'Overtime_Requester.fullname', 
            headerName: 'Pegawai',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.Overtime_Requester.nip} - {params.row.Overtime_Requester.fullname} 
                    </div>
                )
            } 
        },
        { 
            field: 'Overtime_Requester.Biodata.Echelon.title', 
            headerName: 'Eselon',
            width: 100, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.Overtime_Requester.Biodata.Echelon.title}
                    </div>
                )
            } 
        },
        { 
            field: 'Overtime_Requester.Biodata.Office.name', 
            headerName: 'Divisi',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.Overtime_Requester.Biodata.Office.name}
                    </div>
                )
            } 
        },
        { 
            field: 'type', 
            headerName: 'Tipe',
            width: 150, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp uppercase'>
                        {params.row.type === 'OVT' ? 'Lembur' : params.row.type}
                    </div>
                )
            } 
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        <span className={`px-2 py-1 ${getStatusRewards(params.row.status)} rounded-full text-white uppercase`}>{params.row.status}</span>
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row items-center gap-3'>
                        <VisibilityIcon fontSize='medium' className="text-slate-400 hover:text-slate-500 cursor-pointer" onClick={() => handleDetail(params.row)}/>
                    </div>
                )
            }
        },
    ]

    const handleDetail = (tempData) => {
        setShowModalDetail(true)
        setData(tempData)
    }

    const reportDatas = datas.map(item => (
		{ 
			"Nama Lengkap": item.Overtime_Requester.fullname, 
			"NIP": item.Overtime_Requester.nip, 
			"Divisi": item.Overtime_Requester.Biodata.Office.name,
			"Mulai": `${dateIndo(item.start_time)} ${timeIndo(item.start_time)}`, 
			"Sampai": `${dateIndo(item.end_time)} ${timeIndo(item.end_time)}`, 
			"Note": item.note, 
			"Tipe": item.type, 
            // "Photo": item.photo ? `https://binar.hadiahkugratis.com/api-BinarHC/images/${item.photo}` : "",
			"Status": item.status,
            "Admin": item.Overtime_Approver?.fullname
		}
	));

    return (
        <>
            {showModalFilter && 
                <ModalFilterOvertime setShowModalFilter={setShowModalFilter} setDatas={setDatas} setFetchMore={setFetchMore} setStartTime={setStartTime} setEndTime={setEndTime} setDivision={setDivision} setDivisionSlug={setDivisionSlug} />
            }
            {showModalDetail &&
                <ModalOvertimeDetail setShowModalDetail={setShowModalDetail} data={data} setDatas={setDatas} startTime={startTime} endTime={endTime} divisionSlug={divisionSlug}/>
            }
            {showModalCreate &&
                <ModalOvertimeCreate setShowModalCreate={setShowModalCreate}/>
            }

            <div className={`min-h-[calc(100vh-4rem)] flex flex-col ${showModalFilter && 'fixed min-w-[calc(100vw-16.666667%)]'}`}>
                {/* header  */}
                <div className="my-5 mb-5 mx-7 md:mx-5 flex flex-col md:flex-row justify-between items-start">
                    <div className=' flex flex-col'>
                        <h1 className='font-ssp font-bold text-2xl md:text-3xl'>Lembur / WFA</h1>
                        {startTime 
                            ?
                                <span className='font-ssp font-normal text-sm md:text-xl'>{dateIndo(startTime)} - {dateIndo(endTime)}</span>
                            : ''
                        }

                        {division
                            ? <span className='font-ssp font-normal text-sm md:text-xl'>{division}</span> 
                            : 
                                <span className='font-ssp font-light text-sm md:text-base tracking-wide'>
                                    Lakukan filter tanggal untuk menampilkan data tertentu
                                </span>
                        }
                    </div>
                    <div className='flex flex-row flex-wrap gap-2'>
                        {startTime
                            ? 
                            <div onClick={(e) => fetchPendingOvertimes()} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-gray-400 hover:bg-gray-500 rounded-lg flex text-sm font-medium self-start md:self-end cursor-pointer">
                                    <span className='text-sm text-white font-ssp'>All Pending</span>
                                </div>
                            : ""
                                
                        }
                        <div onClick={(e) => setShowModalFilter(true)} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-green-400 hover:bg-green-500 rounded-lg flex text-sm font-medium self-start md:self-end cursor-pointer">
                            <span className='text-sm text-white font-ssp'>Filter By Date</span>
                        </div>
                        <div onClick={(e) => setShowModalCreate(true)} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-blue-400 hover:bg-blue-500 rounded-lg flex text-sm font-medium self-start md:self-end cursor-pointer">
                            <span className='text-sm text-white font-ssp'>Add New</span>
                        </div>
                        {division
                            ?
                                <ExportToExcel reportDatas={reportDatas} fileName={fileName} color="bg-yellow-500"/>
                            : ""
                        }
                    </div>
                </div>
                {/* content  */}
                <div className="my-5 mb-5 mx-7 md:mx-5 flex">
                    <div className="p-2 w-full bg-white drop-shadow-lg rounded-md flex">
                        <DataGrid
                            autoHeight {...datas}
                            rows={datas}
                            columns={columns}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            rowsPerPageOptions={[10]}
                            checkboxSelection
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar, }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Overtimes